import { getInitialLetters } from "utils/constants";
import styles from "./styles.module.scss";
import { Divider, Spin } from "antd";
import {
  AttachFileIcon,
  CreatedAtIcon,
  CreateTimeIcon,
  DeleteIconRed,
  EyeIcon,
  FilesAttachedIcon,
  NotesAttachmentIcon,
} from "icons";
import moment from "moment";
import { useCurrentUserContext } from "providers";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { ConditionalRenderer } from "components";
export const NoteCard = ({
  data,
  onEditNote,
  handleDeleteNote,
  deleteNoteLoading,
}) => {
  const { translator } = useLanguageTranslator();
  const notesTableTrans = translator("caseDetail.notesTable");

  function stripHtml(html) {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  }

  return (
    <Spin spinning={deleteNoteLoading}>
      <div className={styles.cardContainer} onClick={() => onEditNote(data)}>
        <h3 className={styles.title}>{data?.title || ""} </h3>
        <div className={styles.detailsAndActions}>
          <div className={styles.initialsAndDetails}>
            <div className={styles.initials}>
              {getInitialLetters(data?.name)}
            </div>
            <div className={styles.nameAndSmileNum}>
              <div className={styles.name}>{data?.name}</div>
              <div className={styles.smileNum}>
                {/* {notesTableTrans.relation}: */}
                {data?.recipient}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.createBy}>
          <div className={styles.label}>{notesTableTrans.createdBy}:</div>
          <div className={styles.name}>{data?.loggedUser}</div>
        </div>
        <div className={styles.dateAndTime}>
          <div className={styles.date}>
            <CreatedAtIcon /> {notesTableTrans.createdAt}:
            <span>
              {moment(data?.createdAt, "YYYY-MM-DD HH:mm:ss").format(
                "DD.MM.YY",
              )}
            </span>
          </div>
          <div className={styles.date}>
            <CreateTimeIcon /> {notesTableTrans.time}:
            <span>
              {moment(data?.createdAt, "YYYY-MM-DD HH:mm:ss").format("HH:mm")}
            </span>
          </div>
        </div>
        <div className={styles.noteDetail}>
          {/* <p
            style={{ minHeight: "16px" }}
            className={styles.detail}
            dangerouslySetInnerHTML={{ __html: data?.detail }}
            // title={data?.detail?.replace(/<[^>]+>/g, "")}
          ></p> */}
        </div>
        <div className={styles.filesAndActions}>
          <div className={styles.files}>
            <ConditionalRenderer condition={data?.attachmentCount > 0}>
              <div className={styles.iconWrapper}>
                <FilesAttachedIcon />
              </div>
              <div className={styles.fileLength}>
                {data?.attachmentCount} {translator("files")}
              </div>
            </ConditionalRenderer>
          </div>
          <div className={styles.actions}>
            <div
              className={styles.actionBtn}
              onClick={(e) => {
                e.stopPropagation();
                onEditNote(data);
              }}
            >
              <EyeIcon />
            </div>
            <div
              className={styles.actionBtn}
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteNote(data?.noteId);
              }}
            >
              <DeleteIconRed />
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
};
